import { render, staticRenderFns } from "./Syllabus.vue?vue&type=template&id=71205362&scoped=true&"
import script from "./Syllabus.vue?vue&type=script&lang=js&"
export * from "./Syllabus.vue?vue&type=script&lang=js&"
import style0 from "./Syllabus.vue?vue&type=style&index=0&id=71205362&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71205362",
  null
  
)

export default component.exports